import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import GlobalStyle from "./globalStyle";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <GlobalStyle/>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);


